// @ts-check

import React from 'react'
import FreelancerInvoiceItem from '../../../Domain/FreelancerInvoiceItem';
import ColButton from '../../../Elements/ColButton';
import LoadingIcon from '../../../Elements/LoadingIcon';
import OverWindow from '../../../Elements/OverWindow';
import ShowEntityData from '../../../Elements/ShowEntityData';
import FreelancerInvoiceService from '../../../Services/FreelancerInvoiceService';
import CaspianImage from '../../../Elements/CaspianImage';
import ErrorMessage from '../../../Elements/ErrorMessage';
import ButtonFooterContainer from '../../../Elements/ButtonFooterContainer';

class ApproveInvoiceImageWindow extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            saving: false,
        };
    }




    renderInfo() {
        let classNameForInfo = "p-1 m-1"
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12 col-lg-5 text-center">
                        <CaspianImage
                            src={() => FreelancerInvoiceService.GetInvoiceImageFile(this.props.freelancerInvoiceId)} //it has to be a service promise
                            fileName={this.props.data.Filename}
                            alt={"Invoice"}
                            style={{
                                maxWidth: "100%",
                                maxHeight: "60vh"
                            }}
                            enlargementEnabled={false}
                        />
                    </div>
                    <div className="col-sm-12 col-lg-7">
                        <div className={classNameForInfo + " h5 text-center"}>Info</div>
                        <div className={classNameForInfo}>
                            <ShowEntityData
                                itemId={this.props.freelancerInvoiceId}
                                entityName="Vendor Invoice"
                                type={FreelancerInvoiceItem}
                                serviceGetByIdFunction={FreelancerInvoiceService.GetFreelancerInvoiceById}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    clickOnDismissButton() {
        FreelancerInvoiceService.DismissInvoiceImageFile(this.props.freelancerInvoiceId)
            .then(result => this.props.clickOnCancel(true))
            .catch(error => {
                ErrorMessage.SetErrorMessage("AIIW79");
                this.setState({ saving: false });
            });
    }


    clickOnApproveButton() {
        FreelancerInvoiceService.ApproveInvoiceImageFile(this.props.freelancerInvoiceId)
            .then(result => {
                this.props.clickOnCancel(true);
            })
            .catch(error => {
                ErrorMessage.SetErrorMessage("AIIW79");
                this.setState({ saving: false });
            });
    }

    renderButtons() {
        return (
            <ButtonFooterContainer>
                    <ColButton
                        text="Cancel"
                        onClick={this.props.clickOnCancel}
                        spinning={this.state.saving}
                        disabled={this.state.saving}
                    />
                    <ColButton
                        text="Dismiss"
                        icon={"fa-solid fa-thumbs-down" + (this.state.loading ? " fa-spin" : "")}
                        spinning={this.state.saving}
                        onClick={this.clickOnDismissButton.bind(this)}
                    />
                    <ColButton
                        text="Approve"
                        icon={"fa-solid fa-thumbs-up" + (this.state.loading ? " fa-spin" : "")}
                        spinning={this.state.saving}
                        onClick={this.clickOnApproveButton.bind(this)}
                    />
            </ButtonFooterContainer>
        );
    }

    render() {
        return (
            <OverWindow
                clickOnCancel={() => this.props.clickOnCancel(false)}
                title="Approve Invoice Image"
                closeOnClickOutside={false}
                iconName="fa-solid fa-eye"
                verticalScroll={true}
                minHeight="700px"
            >
                <div className="m-2 p-2">
                    {this.renderInfo()}
                </div>
                <LoadingIcon loading={this.state.saving} />
                {this.renderButtons()}
            </OverWindow>
        );

    }
}


export default ApproveInvoiceImageWindow;
